<template>
  <div class="dashboard">
    <div class="buttons">
      <router-link v-if="canEdit" to="/media/create" tag="button">{{ $t('buttons.uploadMedia') }}</router-link>
      <router-link to="/reports" tag="button" class="alt-btn">{{ $t('buttons.createReports') }}</router-link>
    </div>
    <h1>{{ $t('nav.media') }}</h1>
    <div class="image-stats">
      <router-link v-for="stat in stats" :key="stat.key" class="stat" :to="{ path: 'media', query: stat.query }" tag="div">
        <div class="count">{{ stat.value }}</div>
        <div class="label">{{ $t(stat.label) }}</div>
        <div class="link">{{ $t('buttons.view') }}</div>
      </router-link>
    </div>
    <router-link to="/media" tag="button">{{ $t('buttons.viewMedia') }}</router-link>
  </div>
</template>

<script>
import { GET_DASHBOARD_STATS } from '@/store/actions.type'

export default {
  name: 'dashboard',
  data() {
    return {
      boxes: [{
        key: 'live',
        label: 'dashboard.liveMedia',
        query: {
          status: 'live'
        }
      },{
        key: 'expire_soon',
        label: 'dashboard.expiringSoon',
        query: {
          expire: 7
        }
      },{
        key: 'live_soon',
        label: 'dashboard.goingLiveSoon',
        query: {
          live: 7
        }
      },{
        key: 'incomplete',
        label: 'dashboard.incomplete',
        query: {
          status: 'incomplete'
        }
      }]
    }
  },
  computed: {
    canEdit() {
      return this.$store.getters.canEdit
    },
    stats() {
      return this.boxes.map(box => Object.assign({}, box, { value: this.$store.state.dashboard.stats[box.key] }))
    }
  },
  created() {
    const loader = this.$loading.show()
    this.$store.dispatch(GET_DASHBOARD_STATS)
      .finally(() => {
        loader.hide()
      })
  }
}
</script>

<style lang="scss" scoped>
.buttons {
  margin-bottom: 54px;

  button + button {
    margin-left: 25px;
  }
}
.image-stats {
  display: flex;
  margin-left: -25px;
  margin-bottom: 25px;
  overflow: hidden;

  .stat {
    background-color: #fff;
    box-sizing: border-box;
    cursor: pointer;
    margin-left: 25px;
    padding: 32px 75px 32px 35px;
    position: relative;
    width: calc(25% - 25px);
    
    .count {
      font-size: em(80);
      font-weight: 600;
      line-height: 1;
    }

    .label {
      font-size: em(24);
    }

    .link {
      color: #35BDD1;
      font-weight: 600;
      position: absolute;
      bottom: 35px;
      right: 32px;
    }
  }
}
</style>
